import { Route } from "react-router-dom";

import { ProtectedRouter } from "../ProtectedRouter";
import { AuthLayout } from "./AuthLayout";
import { OnboardingLayout } from "./OnboardingLayout";
import { View } from "./View";

export const AppLayout = () => {
  return (
    <ProtectedRouter
      isAccessAllowed={true}
      unprotectedRoutes={<Route path="*" element={<AuthLayout />} />}
      protectedRoutes={
        <>
          <Route
            path="/onboarding/*"
            element={
              <>
                <OnboardingLayout />
              </>
            }
          />

          <Route path="*" element={<View />} />
        </>
      }
    />
  );
};
